import WebNotificationData from "@/classes/notifications/WebNotificationData";
import {EventBus}          from "@/classes/notifications/EventBus";
import {RootEventTypes}    from "@/classes/notifications/EventTypes";

export default function $toast(toast: WebNotificationData) {
	EventBus.getInstance().emit(RootEventTypes.WebNotification, {data: toast});
}

